import { post, get } from '@/utils/request'

// 获取团购列表
export function getGroupBuyList(data) {
  return post('admin/leifeng_groupbuy/getList', data)
}

// 获取团购详情
export function getGroupBuyDetail(data) {
  return post('admin/leifeng_groupbuy/getDetail', data)
}

// 发起团购
export function addGroupBuy(data) {
  return post('admin/leifeng_groupbuy/add', data)
}

// 编辑团购
export function editGroupBuy(data) {
  return post('admin/leifeng_groupbuy/edit', data)
}

// 团购审核通过
export function auditGroupBuyPass(data) {
  return post('admin/leifeng_groupbuy/auditPass', data)
}

// 团购审核拒绝
export function auditGroupBuyReject(data) {
  return post('admin/leifeng_groupbuy/auditReject', data)
}

// 删除团购
export function deleteGroupBuy(data) {
  return post('admin/leifeng_groupbuy/delete', data)
}

// 获取团长列表（下拉选择用）
export function getLeaderList(data) {
  return post('admin/leifeng_groupbuy/leaderList', data)
}

// 获取团购订单列表
export function getGroupBuyOrderList(data) {
  return post('admin/leifeng_groupbuy/orderList', data)
}

// 获取团购订单详情
export function getGroupBuyOrderDetail(data) {
  return post('admin/leifeng_groupbuy/orderDetail', data)
}

// 团购订单发货（支持批量）
export function shipGroupBuyOrder(data) {
  return post('admin/leifeng_groupbuy/shipOrder', data)
}
